"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBrand = void 0;
var CardBrand;
(function (CardBrand) {
    CardBrand["Verve"] = "verve";
    CardBrand["Visa"] = "visa";
    CardBrand["Mastercard"] = "mastercard";
    CardBrand["Maestro"] = "maestro";
    CardBrand["AmericanExpress"] = "american-express";
    CardBrand["Jcb"] = "jcb";
    CardBrand["DinersClub"] = "diners-club";
    CardBrand["Discover"] = "discover";
    CardBrand["Aura"] = "aura";
    CardBrand["Elo"] = "elo";
    CardBrand["Hipercard"] = "hipercard";
    CardBrand["CartesBancaires"] = "cartes-bancaires";
    CardBrand["Rupay"] = "rupay";
    CardBrand["BCCard"] = "bc-card";
    CardBrand["UnionPay"] = "unionpay";
    CardBrand["Dankort"] = "dankort";
    CardBrand["GPNCard"] = "gpn-card";
    CardBrand["Troy"] = "troy";
    CardBrand["ThaiPaymentNetwork"] = "thai-payment-network";
    CardBrand["MADA"] = "mada";
    CardBrand["Bancontact"] = "bancontact";
    CardBrand["Interac"] = "interac";
    CardBrand["Bajaj"] = "bajaj";
})(CardBrand = exports.CardBrand || (exports.CardBrand = {}));
exports.default = CardBrand;
